import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
  SCREEN_HUGE,
} from '../../../../config/constants';

import {
  ButtonWrapper,
} from '../../../../components';


import './style.scss';

const HomeDetail = ({ entity }) => {
  const homeDetail = entity.toJS();
  const title = entity.getIn(['title', 0, 'value']);
  const links = entity.getIn(['field_hero_link']);
  const body = entity.getIn(['field_hero_body', 0, 'value']);
  const alt = homeDetail.field_hero_image[0].title;

  const imageStyles = homeDetail.field_hero_image[0].styles;
  const src = {
    [SCREEN_MOBILE]: imageStyles['4_5_small'],
    [SCREEN_TABLET]: imageStyles.image_paragraph,
    [SCREEN_NORMAL]: imageStyles['21_9_normal'],
    [SCREEN_WIDE]: imageStyles['21_9_wide'],
    [SCREEN_HUGE]: imageStyles['32_9_huge'],
  };

  return (
    <article className="NodeHome">

      <div className="NodeHome__hero">
        <div className="NodeHome__hero__background">
          <div className="NodeHome__hero__overlay" />
          <div className="NodeHome__hero__image">
            <Image
              src={src}
              lazyload={false}
              alt={alt}
            />
          </div>
          <div className="NodeHome__hero__bar" />
        </div>

        <Container>
          <div className="row">
            <div className="NodeHome__content col-12 col-md-9 col-lg-6 ">
              <h1 className="NodeHome__title">{title}</h1>
              <WysiwygField
                property="schema:text"
                className="NodeHome__body"
                html={body}
              />
              <div className="NodeHome__links">
                {links && links.map((link, index) => {
                  const linkTitle = link.get('title');
                  const linkUri = link.getIn(['alias'], link.get('uri'));

                  return (
                    <ButtonWrapper type={index === 0 ? 'primary' : 'inverted'} href={linkUri} key={linkTitle}><span>{linkTitle}</span></ButtonWrapper>
                  );
                })}
              </div>
            </div>
          </div>
        </Container>
        <div className="NodeHome__shadow" />
      </div>


      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <div key={`paragraph:${id}:${language}`} id={id} className="ParagraphAnchorWrapper">
                <Paragraph
                  key={`paragraph:${id}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </div>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}
    </article>
  );
};

export default HomeDetail;
